
import { Vue, Component, Prop } from 'vue-property-decorator';
import { SanityDocumentSchema } from '~/types/sanity-documents';
import { ISanityObjects, SanityObjectSchema } from '~/types/sanity-objects';
import { MuxStreamTypes } from '~/types/mux-player';
import SanityReference from '~/components/Sanity/SanityReference.vue';
import VideoPlayer from '~/components/Player/VideoPlayer.vue';
import WatchVideoDialog from '~/components/Sanity/WatchVideoDialog.vue';

@Component({
  components: {
    SanityReference,
    VideoPlayer,
    WatchVideoDialog,
  },
})
export default class SanityRowHeroVideo extends Vue {
  @Prop({ type: Number, default: 2.4 })
  readonly aspectRatio!: number;
  @Prop({ type: Object, default: () => ({}) })
  readonly data!: ISanityObjects[SanityObjectSchema.ROW_HERO_VIDEO];
  @Prop(Boolean)
  readonly isHeroLayout!: boolean;
  @Prop({ type: Boolean, default: true })
  readonly hasContentContainer!: boolean;

  schemas = SanityDocumentSchema;
  streamTypes = MuxStreamTypes;
  videoSchemas = [
    SanityDocumentSchema.VIDEO,
    SanityDocumentSchema.VIDEO_LIVE_STREAM,
  ];
}
